import { EditorContent, useEditor } from '@tiptap/react';
import Color from '@tiptap/extension-color';
import StarterKit from '@tiptap/starter-kit';
import ListItem from '@tiptap/extension-list-item';
import TextStyle from '@tiptap/extension-text-style';
import Link from '@tiptap/extension-link';
import { Markdown } from 'tiptap-markdown';
import useOnceCallback from '../hooks/useOnceCallback';

// uneditable editor used to display markdown values
const MarkdownDisplay = ({ value }: { value?: string }) => {
  const extensions = [
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    StarterKit.configure({
      bulletList: {
        keepMarks: true,
      },
      orderedList: {
        keepMarks: true,
      },
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
      defaultProtocol: 'https',
    }),
    Markdown,
  ];

  const editor = useEditor({
    extensions,
    content: value,
    // since this component is to display only, editable is set to false
    editable: false,
  });

  // programmatically set the value of the editor
  useOnceCallback(
    () => {
      if (value) editor?.commands.setContent(value);
    },
    // runs when value and editor are not null
    !!(value && editor),
  );

  return <EditorContent editor={editor} />;
};

export default MarkdownDisplay;
